import React, {useState, useEffect} from 'react';
import styles from './Fleet.module.css';

import robot1 from '../../static_files/robot1.png';
import robot2 from '../../static_files/robot2.png';
import robot3 from '../../static_files/robot3.png';
import robot4 from '../../static_files/robot4.png';
import robot5 from '../../static_files/robot5.png';
import robot6 from '../../static_files/robot6.png';
import robot7 from '../../static_files/robot7.png';
import robot8 from '../../static_files/robot8.png';

import RobotModal from "./RobotModal";
import ReserveInfoModal from "./ReserveInfoModal";
import UpgradeMembershipModal from "./UpgradeMembershipModal";
import {useLocation, useNavigate} from 'react-router-dom';

const commonModalFooter = {
    reserveLinkText: 'Ready to operate? Reserve this robot now and start your mission.',
};

const allRobotsData = [
    {
        id: 1,
        name: 'Unitree G1',
        cardImage: robot1,
        modalImageUrl: robot1,
        description: "Unitree G1 is a 2/3 height (1.2 meter) tall humanoid robot that weighs just 35 kg, allowing easy transportation including by air. Its compact size makes it ideal for conferences, advertising, and tourism. The G1 is a mature, turnkey platform great for head-turning, set-and-forget demos.",
        tags: ['Advertising', 'Tour Guide', 'Conferences'],
        productOverview: {
            'Robot Configuration': 'humanoid biped',
            'Locomotion': '6-DOF legs (13-DOF total)',
            'Manipulation': 'N/A (3-DOF arms)',
            'Run-Time': '3h',
            'Sensors': 'LIDAR',
            'Compute': '8-core RK3588'
        },
        ...commonModalFooter
    },
    {
        id: 2,
        name: 'Ubtech Walker',
        cardImage: robot2,
        modalImageUrl: robot2,
        description: "The Ubtech Walker is a full-size humanoid with 41 degrees of freedom, advanced vision systems, and dual NVIDIA Orin AGX computers. It has an open-source SDK and is capable of completing diverse tasks.",
        tags: ['Foodservice', 'Light Warehousing', 'Tour Guide', 'Advertising', 'Locomotion Research'],
        productOverview: {
            'Robot Configuration': 'dexterous humanoid biped',
            'Locomotion': '6-DOF legs (13-DOF total)',
            'Manipulation': '7-DOF arms + dexterous hands',
            'Run-Time': '4h (hot-swappable)',
            'Sensors': 'stereo cameras, LIDAR',
            'Compute': '2x Orin AGX 64 GB'
        },
        ...commonModalFooter
    },
    {
        id: 3,
        name: 'Pollen Robotics Reachy 2',
        cardImage: robot3,
        modalImageUrl: robot3,
        description: "Reachy 2 is an open-source bimanual humanoid built by Pollen Robotics (now part of Hugging Face). Reachy 2's arms use a unique parallel kinematic design with one tripod actuator and two bipod actuators to allow for singularity-free 7-DoF positioning, giving AI practitioners easy to use hardware so they can focus on building models.",
        tags: ['Manipulation Research', 'Light Manual Tasks'],
        productOverview: {
            'Robot Configuration': 'wheeled dexterous humanoid',
            'Locomotion': 'Omnidirectional wheeled platform',
            'Manipulation': '7-DOF arms (14 total) + 1-DOF parallel gripper (2 total)',
            'Run-Time': '4h',
            'Sensors': 'Stereo camera + ToF (in head), RGB-D camera (torso), LIDAR (base)',
            'Compute': 'Customer supplied'
        },
        ...commonModalFooter
    },
    {
        id: 4,
        name: 'K-Scale Labs K-Bot',
        cardImage: robot4,
        modalImageUrl: robot4,
        description: "The K-Scale Labs K-Bot is a midsize humanoid focused on compatibility with the latest and most advanced end-to-end AI models. It is built on a modern and developer friendly technology stack (integrated motor actuators, stereo vision, familiar single board computers) and has a 100% open source software stack. It also supports modular end effectors.",
        tags: ['Humanoid Research', 'Education', 'Light Manual Tasks'],
        productOverview: {
            'Robot Configuration': 'humanoid biped',
            'Locomotion': '5-DOF legs (10 total)',
            'Manipulation': '5-DOF arms (10 total) + modular end effectors',
            'Run-Time': 'Customer supplied',
            'Sensors': 'Stereo camera',
            'Compute': 'Customer supplied'
        },
        ...commonModalFooter
    },
    {
        id: 5,
        name: 'Boardwalk Robotics Alex',
        cardImage: robot5,
        modalImageUrl: robot5,
        description: "The Boardwalk Robotics Alex is a dexterous humanoid upper body with high-power actuators capable of high speed and high payloads. It is a great platform for building heavier use cases such as manufacturing and maintenance. Makes a great DJ too!",
        tags: ['Manipulation Research', 'Maintenance', 'Manufacturing'],
        productOverview: {
            'Robot Configuration': 'humanoid torso',
            'Locomotion': 'Customer supplied',
            'Manipulation': '7-DOF arms + 2-DOF hands (+articulated neck)',
            'Run-Time': 'Customer supplied',
            'Sensors': 'Stereo camera',
            'Compute': 'Customer supplied'
        },
        ...commonModalFooter
    },
    {
        id: 6,
        name: 'Enchanted Tools Mirokai',
        cardImage: robot6,
        modalImageUrl: robot6,
        description: "The Enchanted Tools Mirokai brings the heritage of Softbank/Aldebaran's Nao and Pepper humanoids to the modern age with a unique self-balancing locomotion system, compliant arms and dexterous hands, and an emotionally expressive face. Mirokai is perfect for applications involving human interaction, hospitality, or companionship.",
        tags: ['Companionship', 'Conferences', 'Hospitality'],
        productOverview: {
            'Robot Configuration': 'self-balancing dexterous humanoid',
            'Locomotion': 'Self-balancing ball driven by omnidirectional wheels',
            'Manipulation': '7-DOF arms (14 total) + dexterous hands',
            'Run-Time': '4h',
            'Sensors': 'Stereo camera + ToF + ultrasonic',
            'Compute': 'NVIDIA GPU'
        },
        ...commonModalFooter
    },
    {
        id: 7,
        name: 'MIT Mini-Cheetah',
        cardImage: robot7,
        modalImageUrl: robot7,
        description: "This is a first generation copy of the original MIT mini-Cheetah robot. It weighs just 10kg, can be easily transported in carry-on luggage, and is capable of multiple highly dynamic movements including backflips. It is also fully compatible with the open-source MIT codebase, making it ideal for research.",
        tags: ['Locomotion Research', 'Conferences', 'Advertising'],
        productOverview: {
            'Robot Configuration': 'quadruped',
            'Locomotion': '3-DOF legs (12-DOF total)',
            'Manipulation': 'Customer supplied',
            'Run-Time': '2h',
            'Sensors': 'Customer supplied',
            'Compute': 'quad-core Intel Atom'
        },
        ...commonModalFooter
    },
    {
        id: 8,
        name: 'Unitree Go2-W',
        cardImage: robot8,
        modalImageUrl: robot8,
        description: "The Unitree Go2-W is a commercially mass-produced wheeled quadruped capable of some extremely dynamic motions, including skating, handstanding, stair-climbing, and handling 70 cm tall obstacles. It sports a full set of advanced quadruped features and is great for frontier locomotion research. It also makes a great demo!",
        tags: ['Locomotion Research', 'Advertising', 'Inspection'],
        productOverview: {
            'Robot Configuration': 'wheeled quadruped',
            'Locomotion': '3-DOF legs (12 total) + wheels',
            'Manipulation': 'Customer supplied',
            'Run-Time': '2.5h',
            'Sensors': 'LIDAR',
            'Compute': 'Customer supplied'
        },
        ...commonModalFooter
    }
];

const Fleet = ({showPanel, setShowPanel}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [showRobotModal, setShowRobotModal] = useState(false);
    const [selectedRobotData, setSelectedRobotData] = useState(null);

    const [showReserveInfoModal, setShowReserveInfoModal] = useState(false);
    const [robotNameToReserve, setRobotNameToReserve] = useState('');

    const [showUpgradeModal, setShowUpgradeModal] = useState(false);
    const [isPaymentRedirect, setIsPaymentRedirect] = useState(false);
    const groupRobotsIntoRows = (robots, itemsPerRow) => {
        const rows = [];
        for (let i = 0; i < robots.length; i += itemsPerRow) {
            rows.push(robots.slice(i, i + itemsPerRow));
        }
        return rows;
    };

    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.get('payment') === 'success' && searchParams.has('session_id')) {
            setShowUpgradeModal(true);
            setIsPaymentRedirect(true);

            navigate(location.pathname, {replace: true});
        }
    }, [location.search, navigate]);
    const handleCloseUpgradeModal = () => {
        setShowUpgradeModal(false);
        setIsPaymentRedirect(false);
    };
    const handleShowRobotModal = (robot) => {
        setSelectedRobotData(robot);
        setShowRobotModal(true);

    };

    const handleCloseRobotModal = () => {
        setShowRobotModal(false);
    };

    const handleOpenReserveInfoModal = (robotName) => {
        setShowRobotModal(false);
        setRobotNameToReserve(robotName);
        setShowReserveInfoModal(true);
    };

    const handleCloseReserveInfoModal = () => {
        setShowReserveInfoModal(false);
        setRobotNameToReserve('');
        setSelectedRobotData(null); // Clear data after reservation flow finishes
    };

    const handleGoBackFromReserveToDetails = () => {
        setShowReserveInfoModal(false);
        setRobotNameToReserve('');
        if (selectedRobotData) {
            setShowRobotModal(true);
        } else {
            handleCloseReserveInfoModal(); // Or other appropriate fallback
        }
    };

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 1000);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const renderTags = (robot) => {
        if (isMobile) return null;
        if (robot.name === 'Ubtech Walker' && robot.tags.length > 3) {
            return (
                <div className={styles.tagsContainerSpecial} style={{marginTop: '-10px'}}>
                    <div className={styles.tagRow}>
                        {robot.tags.slice(0, 3).map((tag, index) => (
                            <span key={index} className={styles.tag}>{tag}</span>
                        ))}
                    </div>
                    <div className={styles.tagRow}>
                        {robot.tags.slice(3).map((tag, index) => (
                            <span key={index + 3} className={styles.tag}>{tag}</span>
                        ))}
                    </div>
                </div>
            );
        }
        return (
            <div className={styles.tagsContainer}>
                {robot.tags.map((tag, index) => (
                    <span key={index} className={styles.tag}>{tag}</span>
                ))}
            </div>
        );
    };

   return (
        <div className={styles.fleetOuterContainer}>
            <h1 className={styles.fleetTitle}>Welcome! Meet our fleet of robots selected to help you...</h1>
            <div className={styles.fleetContainer}>
                <div className={`${styles.robotsGrid} ${styles.desktopGrid}`}>
                    {allRobotsData.map(robot => (
                        <div
                            key={robot.id}
                            className={styles.robotCard}
                            onClick={() => handleShowRobotModal(robot)}
                        >
                            <h3 className={styles.robotName}>{robot.name}</h3>
                            <div className={styles.robotImageContainer}>
                                <img
                                    src={robot.cardImage}
                                    alt={robot.name}
                                    className={styles.robotImage}
                                />
                            </div>
                            {renderTags(robot)}
                        </div>
                    ))}
                </div>

                <div className={styles.mobileRows}>
                    {groupRobotsIntoRows(allRobotsData, 3).map((row, rowIndex) => (
                        <div key={rowIndex} className={styles.robotRow}>
                            {row.map(robot => (
                                <div
                                    key={robot.id}
                                    className={styles.robotCard}
                                    onClick={() => handleShowRobotModal(robot)}
                                >
                                    <h3 className={styles.robotName}>{robot.name}</h3>
                                    <div className={styles.robotImageContainer}>
                                        <img
                                            src={robot.cardImage}
                                            alt={robot.name}
                                            className={styles.robotImage}
                                        />
                                    </div>
                                    {renderTags(robot)}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>


                {showRobotModal && selectedRobotData && (
                    <RobotModal
                        onClose={handleCloseRobotModal}
                        robotData={selectedRobotData}
                        onOpenReserveForm={handleOpenReserveInfoModal}
                        setShowPanel={setShowPanel}
                        showPanel={showPanel}
                    />
                )}

                {showReserveInfoModal && robotNameToReserve && (
                    <ReserveInfoModal
                        onClose={handleCloseReserveInfoModal}
                        onGoBack={handleGoBackFromReserveToDetails}
                        robotName={robotNameToReserve}
                        robotImage={selectedRobotData.cardImage}
                    />
                )}
                {showUpgradeModal && (
                    <UpgradeMembershipModal
                        onClose={handleCloseUpgradeModal}
                        onGoBack={handleCloseUpgradeModal}
                        paymentSuccess={isPaymentRedirect}
                    />
                )}
            </div>
        </div>

    );
};

export default Fleet;